import { IGetItemsResult } from '../../../ts/ServerApi/types/IGetItemsResult';
import { IListFetcher } from '../../../ts/fetchers/IListFetcher';
import { IPagedItemsParams } from '../../../ts/ServerApi/types/IPage';
import { ListResult } from '../../../ts/fetchers/ListResult';
import { Request } from '../../../httpClient/serverApi/requests/Request';
import WebHttpClient from '../../../httpClient/WebHttpClient';

export class WebClientListResourceFetcher<
  TResource,
  TRequestResult extends IGetItemsResult> implements IListFetcher<TResource> {

  constructor(
    private requestType: new (params: IPagedItemsParams) => Request<IPagedItemsParams, TRequestResult>,
    private resultMapper: (result: TRequestResult) => TResource[]
  ) { }

  public fetchList(params: IPagedItemsParams): Promise<ListResult<TResource>> {
    return WebHttpClient.sendRequest(new this.requestType(params))
      .then((result: TRequestResult) => {
        const startIndex = params.page ? params.page.startIndex : 0;
        return new ListResult<TResource>(this.resultMapper(result), startIndex, result.totalCount);
      });
  }

}
